import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { useForm, FormProvider } from "react-hook-form";
import { getCookieValue } from "../../utils/cookies/getCookieValue.esm.js";
import HighTouchScript from "../HighTouchScript/HighTouchScript.esm.js";
import SimonScript from "../SimonScript/SimonScript.esm.js";
import { onError } from "./SimonForm.utils.esm.js";
const getSanitizedCookieValue = (cookieName) => {
  const rawValue = getCookieValue(cookieName);
  if (!rawValue) {
    return null;
  }
  let decodedValue = rawValue;
  try {
    decodedValue = decodeURIComponent(rawValue);
  } catch {
    decodedValue = rawValue;
  }
  const unquotedValue = decodedValue.replace(/^"+|"+$/g, "");
  return unquotedValue.replace(/[^A-Za-z0-9\-_]/g, "");
};
const SimonForm = ({
  persona,
  storageEnvironment,
  subscriptionListName,
  treatmentName,
  children,
  id
}) => {
  const methods = useForm({
    mode: "onTouched"
  });
  const onSubmit = (data, e) => {
    var _a;
    const properties = {
      eventName: "CMS Simon Form",
      persona,
      subscriptionListName,
      treatmentName
    };
    Object.keys(data).forEach((key) => {
      if (key !== "email") {
        properties[key] = data[key];
      }
    });
    const userId = getSanitizedCookieValue("zjs_user_id");
    const anonymousId = getSanitizedCookieValue("zjs_anonymous_id");
    window.sd.identify(userId, {
      ...data.email && {
        email: data.email
      },
      properties
    });
    const highTouchProperties = {
      ...properties,
      ...data.email && {
        email: data.email
      },
      ...userId && {
        userId
      },
      ...anonymousId && {
        anonymousId
      }
    };
    if (window.htevents && window.htevents.track) {
      window.htevents.track("CMS Simon Form", highTouchProperties, {
        page: {
          referrer: document.referrer || void 0,
          url: window.location.href
        }
      });
    }
    const formElement = e == null ? void 0 : e.target;
    event({
      // https://dataportal.zillowgroup.net/event-registry/2055
      envelope: {
        event_type_id: "2055",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_button",
        trigger_object_nm: "no_trigger_object"
      },
      cms_info: {
        block_id: (formElement == null ? void 0 : formElement.id) || "",
        block_type_cd: "simon_data_form",
        form_submit_label: ((_a = formElement == null ? void 0 : formElement.querySelector('[type="submit"]')) == null ? void 0 : _a.textContent) ?? ""
      }
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SimonScript, { storageEnvironment }),
    /* @__PURE__ */ jsx(HighTouchScript, { storageEnvironment }),
    /* @__PURE__ */ jsx(FormProvider, { ...methods, children: /* @__PURE__ */ jsx("form", { onSubmit: methods.handleSubmit(onSubmit, onError), id, noValidate: true, children }) })
  ] });
};
export {
  SimonForm as default
};
